import type { TmsInvoiceRow } from '@numeo/types-main-web-app'
import { useInvoicingRowsStore } from '../../../invoicing/rowsStore'
import { log } from '@/utils/logger'
import { absenceOf, type LoadAbsence } from './LoadAbsence'

/**
 * Reads one load's invoicing row again and patches the shared rows store, so the table, the drawer and a chat card all show the
 * same state. With no row, `absence` says why: still on the road, not found, or the read failed (`unread`, never "not delivered").
 */
export const readInvoicingRow = async (loadNumber: string): Promise<{ row?: TmsInvoiceRow; absence: LoadAbsence }> => {
    try {
        const [readiness] = await useInvoicingRowsStore.getState().refresh([loadNumber])
        const row = useInvoicingRowsStore.getState().rows[loadNumber]
        return { row, absence: absenceOf(readiness, loadNumber) }
    } catch (error) {
        log.w('[invoicing] load row not read', { loadNumber, error })
        return { absence: 'unread' }
    }
}

/** The same read, for a caller that needs only the row: undefined when the load has none or the read fails (the caller keeps what it shows). */
export const refreshInvoicingRow = async (loadNumber: string): Promise<TmsInvoiceRow | undefined> => (await readInvoicingRow(loadNumber)).row
